'use client'

import { useState } from 'react'
import BurgerMenu from './BurgerMenu'
import BurgerMenuButton from './BurgerMenuButton'

export default function BurgerMenuWrapper({ links }: { links: any }) {
	const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false)

	return (
		<>
			<BurgerMenuButton onClick={() => setIsBurgerMenuOpen(true)} />
			<BurgerMenu isOpen={isBurgerMenuOpen} onClose={() => setIsBurgerMenuOpen(false)} links={links} />
		</>
	)
} 